import { createApp } from 'vue';
import '@Styles/main.css';
import Directives from '@Directives';
import Libraries, { startAssetPinning } from '@Libraries';
import Plugins from '@Plugins';
import App from './App.vue';

startAssetPinning();

const app = createApp(App);

Directives.forEach(({ name, directive }) => app.directive(name, directive));
Libraries.forEach((lib) => app.use(lib));
Plugins.forEach((plugin) => app.use(plugin));

app.mount('#app');
